module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Create Web User","introduction":["Once you create this account, the email address you provide will be sent instructions on how to set a password and proceed."]}}')
  delete Component.options._Ctor
}
